import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { fundingSources as fundingSourcesData } from 'data';
import { ApplicationState } from '../../../../store';
import FinanceQPage1, { IDispatchProps, IProps } from './index';
import {
  saveDeposit,
  createOrganisationSponsor,
  createScholarshipSponsor,
  createEducationSponsor,
  createFamilySponsor,
  createOtherSponsor,
  updateOrganisationSponsor,
  updateScholarshipSponsor,
  updateEducationSponsor,
  updateFamilySponsor,
  updateOtherSponsor,
  removeOrganisationSponsor,
  removeScholarshipSponsor,
  removeEducationSponsor,
  removeFamilySponsor,
  removeOtherSponsor,
  removeOrganisationRegion,
  removeScholarshipRegion,
  removeEducationRegion,
  removeFamilyRegion,
  removeOtherRegion,
} from '../../../../store/student/actions';

// clone once to prevent modification of original
const _fundingSourcesData = fundingSourcesData.map(source => ({ ...source }));

const mapStateToProps = (state: ApplicationState): IProps => {
  // get url
  const { financials } = state.student;
  const { courseFeeDepositReqd, accomDepositReqd } = financials;

  // Force open deposit form if deposit questions were not answered yet and it can be edited
  const missingDeposit = !courseFeeDepositReqd || !accomDepositReqd;
  const forceShowDeposit = !state.student.config.depositUneditable && missingDeposit;

  const tuitionPostDiscount = state.student.config.tuitionPostDiscount ?? false;

  return {
    sectionTitle: state.student.config.Checklist.Finances.shortTitle,
    fundingSourcesData: _fundingSourcesData,
    complete: !!state.student.financials.isSectionComplete,
    currentStep: 1,
    steps: 1,
    finance: state.student.financials,
    financeDocuments: state.student.financeDocuments,
    offer: state.student.offer,
    history: state.student.history,
    config: state.student.config,
    forceShowDeposit,
    tuitionPostDiscount,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onSaveDeposit: () => dispatch(saveDeposit()),
  onCreateSponsor: (region: string, data: any) => {
    switch (region) {
      case 'organisationSponsorship':
        dispatch(createOrganisationSponsor(data));
        break;
      case 'scholarshipSponsorship':
        dispatch(createScholarshipSponsor(data));
        break;
      case 'educationSponsorship':
        dispatch(createEducationSponsor(data));
        break;
      case 'familySponsorship':
        dispatch(createFamilySponsor(data));
        break;
      case 'otherSponsorship':
        dispatch(createOtherSponsor(data));
        break;
    }
  },
  onUpdateSponsor: (region: string, key: string, data: any) => {
    switch (region) {
      case 'organisationSponsorship':
        dispatch(updateOrganisationSponsor(key, data));
        break;
      case 'scholarshipSponsorship':
        dispatch(updateScholarshipSponsor(key, data));
        break;
      case 'educationSponsorship':
        dispatch(updateEducationSponsor(key, data));
        break;
      case 'familySponsorship':
        dispatch(updateFamilySponsor(key, data));
        break;
      case 'otherSponsorship':
        dispatch(updateOtherSponsor(key, data));
        break;
    }
  },
  onRemoveSponsor: (region: string, key: string) => {
    switch (region) {
      case 'organisationSponsorship':
        dispatch(removeOrganisationSponsor(key));
        break;
      case 'scholarshipSponsorship':
        dispatch(removeScholarshipSponsor(key));
        break;
      case 'educationSponsorship':
        dispatch(removeEducationSponsor(key));
        break;
      case 'familySponsorship':
        dispatch(removeFamilySponsor(key));
        break;
      case 'otherSponsorship':
        dispatch(removeOtherSponsor(key));
        break;
    }
  },
  onRemoveRegion: (region: string) => {
    switch (region) {
      case 'organisationSponsorship':
        dispatch(removeOrganisationRegion());
        break;
      case 'scholarshipSponsorship':
        dispatch(removeScholarshipRegion());
        break;
      case 'educationSponsorship':
        dispatch(removeEducationRegion());
        break;
      case 'familySponsorship':
        dispatch(removeFamilyRegion());
        break;
      case 'otherSponsorship':
        dispatch(removeOtherRegion());
        break;
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FinanceQPage1);
